import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Service.scss';
import useAnalytics from '../../hooks/useAnalytics';

const Service = ({serviceList}) => {
    const { trackEvent, trackServiceCardClicked } = useAnalytics();
    const navigate = useNavigate();
    
    const handleServiceClick = () => {
        // Analytics tracking
        trackEvent('service_card_click', {
            service_id: serviceList.id || serviceList.title,
            service_name: serviceList.title,
            source: 'services_section'
        });
        
        trackServiceCardClicked(
            serviceList.id || serviceList.title,
            serviceList.title,
            'services_section'
        );
        
        // Direct slug varsa tedavi detay sayfasına, yoksa tedaviler sayfasına yönlendir
        if (serviceList.directSlug) {
            navigate(`/tedavi/${serviceList.directSlug}`);
        } else if (serviceList.categorySlug) {
            navigate(`/tedaviler?category=${serviceList.categorySlug}`);
        } else {
            navigate('/tedaviler');
        }
    };
    
    return (
        <div className="col-lg-3 col-sm-6">
            <div className="service-box" onClick={handleServiceClick} style={{cursor: 'pointer'}}>
                <div className="icon-area">
                    {serviceList.image && <img src={serviceList.image} alt={serviceList.title} />}
                </div>
                <div className="service-text">
                    <h3>{serviceList.title}</h3>
                    <p>{serviceList.description}</p>
                </div>
            </div>
        </div>
    );
};

export default Service;